import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const FolderClosed = ({
  height = 24,
  width = 24,
  color = colors.iconFolder,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-test="folder-closed-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className="shape"
    {...props}
  >
    <path
      d="M20.4375 8.0625C20.4375 7.76413 20.319 7.47798 20.108 7.267C19.897 7.05603 19.6109 6.9375 19.3125 6.9375H10.875L9.525 5.1375C9.42021 4.99778 9.28433 4.88438 9.12812 4.80627C8.9719 4.72816 8.79965 4.6875 8.625 4.6875H4.6875C4.38913 4.6875 4.10298 4.80603 3.892 5.017C3.68103 5.22798 3.5625 5.51413 3.5625 5.8125V18.1875C3.5625 18.4859 3.68103 18.772 3.892 18.983C4.10298 19.194 4.38913 19.3125 4.6875 19.3125H19.3125C19.6109 19.3125 19.897 19.194 20.108 18.983C20.319 18.772 20.4375 18.4859 20.4375 18.1875V8.0625Z"
      fill={getColor(color, isColorInherited)}
      stroke="none"
      strokeOpacity="0"
    />
  </SvgIcon>
);
